<template>
    <v-card class="SupportCard">
        <v-card-title>
            <v-spacer></v-spacer>
            <HelpModal v-if="helpText"
                       :text="helpText"
                       :title="helpTitle"
            ></HelpModal>
        </v-card-title>
        <form @submit.prevent="onSubmit()">
            <div class="SupportCard__content">
                <div class="SupportCard__text">
                    <div v-for="(field, id) in fields"
                         :key="namespace+field.id+id"
                         class="FieldWrapper"
                    >
                        <div class="SupportCard__error" v-if="showError">
                            <v-alert type="error" color="primary">{{errorMessage}}</v-alert>
                        </div>

                        <div class="SupportCard__success" v-if="showSuccess">
                            <v-alert type="success" color="primary">{{successMessage}}</v-alert>
                        </div>

                        <Field v-if="field && field.id && !sent"
                               :field-id="field.id"
                               :card-namespace="namespace"
                               :key="namespace+field.id+id"
                        />
                    </div>
                </div>
                <div class="SupportCard__actions">
                    <v-spacer></v-spacer>
                    <v-icon v-if="sending" color="primary" small left>fas fa-spin fa-sync-alt</v-icon>

                    <v-btn color="primary" type="submit" v-if="!sent">
                        <v-icon small left>fas fa-envelope</v-icon>
                        Send
                    </v-btn>
                </div>
            </div>
        </form>
    </v-card>
</template>

<script>
import store from '../../../store/store';
import axios from 'axios';
import Field from '../Field/Field';
import HelpModal from '@/components/HelpModal';

export default {
    components: { HelpModal, Field },
    props: [
        'name',
        'cardHasData',
        'loaded',
        'namespace',
        'fields',
    ],

    computed: {
        helpTitle() {
            return store.state[this.namespace].helpTitle;
        },

        helpText() {
            return store.state[this.namespace].helpText;
        }
    },

    data() {
        return {
            sending: false,
            showError: false,
            errorMessage: '',
            showSuccess: false,
            successMessage: '',
            sent: false,
        };
    },

    methods: {
        /**
         * This is a shameful, sloppy adaptation of the data card submit.
         * I originally intended for this to support more than one field,
         * and it still might, so it remains a mess.
         */
        onSubmit() {
            this.sending = true;
            this.showSuccess = false;
            this.successMessage = '';
            this.showError = false;
            this.errorMessage = '';
            let fields = [];

            this.fields.forEach((field) => {
                const entry = store.getters[`field-user-${field.id}/entry`];
                fields.push({
                    id: field.id,
                    entry: entry
                });
            });

            axios.post('/api/support/submit-form', {'message': fields[0].entry.paragraphText})
                .then(() => {
                    this.sending = false;
                    this.showSuccess = true;
                    this.successMessage = 'Your message was sent successfully.';
                    this.sent = true;
                })

                .catch(error => {
                    this.sending = false;
                    this.showError = true;
                    this.errorMessage = error.response.data.message;
                });
        }
    }
};
</script>

<style lang="scss">
    .SupportCard {
        display: flex;
        flex-flow: row wrap;
        flex: 0 0 100%;
        width: 100%;
        background-color: white;

        form {
            display: flex;
            flex-flow: row wrap;
            flex: 0 0 100%;
            width: 100%;
        }
    }

    .SupportCard__text,
    .SupportCard__actions {
        flex: 0 0 100%;
        width: 100%;
    }

    .SupportCard__text {
        padding: 18px;

        @media (min-width: 600px) {
            padding: 24px 24px 0;
        }

        @media (min-width: 768px) {
            padding: 36px 36px 0;
        }
    }

    .SupportCard__actions {
        display: flex;
        justify-content: flex-end;
        padding: 0 18px 18px;

        @media (min-width: 600px) {
            padding: 0 24px 24px;
        }

        @media (min-width: 768px) {
            padding: 0 36px 36px;
        }
    }

    .SupportCard__content {
        display: flex;
        flex-flow: row wrap;
        flex: 0 0 100%;
        width: 100%;
    }

    .HelpModalWrap {
        padding-right: 18px;

        @media (min-width: 600px) {
            padding-right: 24px;
        }

        @media (min-width: 768px) {
            padding-right: 36px;
        }
    }

    .FieldWrapper {
        display: flex;
        flex-flow: row wrap;
        flex: 0 0 100%;
        width: 100%;
    }

    .SupportCard__error,
    .SupportCard__success {
        flex: 0 0 100%;
        width: 100%;
    }
</style>
